export default "__VITE_ASSET__DLI6XZdi__"